import React, { useState, useEffect } from 'react';

const words = ['Money', 'Place', 'Time'];

const RotatingText = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % words.length);
        }, 3000); // Change to the desired rotation time
        return () => clearInterval(interval);
    }, []);

    return <span className="rotating-text">{words[index]}</span>;
};

export default RotatingText;